<template>

  <div id="report-wrapper-component" class="report-wrapper">


    <div v-if="!reports.active_module" class="d-flex flex-grid">

      <span v-for="report in reports.query_moodules"  class="col text-center" @click="setActive(report)">

        <div class="m-2 text-center card">

          <va-card
          :title="report.module.visual.title"
          >

          <va-icon
          :name="report.module.visual.icon"
          color="primary"
          :large="true"
          size="120px"
          />

          <p class="mt-3">{{ report.module.visual.desc }}</p>

        </va-card>
      </div>

    </span>

  </div>
  
  <div class="row" v-if="reports.active_module && !show_neovis">

    <va-card
    class="flex sm6 xs12" style="margin: 0 auto"
    :title="reports.active_module.module.visual.title"
    >

    <template v-for="binding in reports.active_module.module.binding">
    
      <div v-if="binding[getKey(binding)] == 'date' && hasValue(reports.active_module.module_name)" class="flex xs6 float-left">
        <va-date-picker 
          :name="getKey(binding)"
          v-validate="{ required: true }"
          :config="date.config"
          v-model="values[reports.active_module.module_name][getKey(binding)]"    
          :label="binding.label"
          :error="errors.has(getKey(binding)) ? true : false"
          :error-messages="cleanMessage(errors.first(getKey(binding)),getKey(binding),binding.label)"
        >
        </va-date-picker>
      </div>

      <div v-if="binding[getKey(binding)] == 'array'" class="flex xs12">

        <vue-tags-input
        :placeholder="binding.label"
        v-model="values[reports.active_module.module_name][getKey(binding,'tag_')]"
        :tags="values[reports.active_module.module_name][getKey(binding)]"
        @tags-changed="newTags => values[reports.active_module.module_name][getKey(binding)] = newTags"
        />

      </div>

      <div v-if="binding[getKey(binding)] == 'string'" class="flex xs12">
        <va-input
        :name="getKey(binding)"
        type="text"
        v-model="values[reports.active_module.module_name][getKey(binding)]"
        v-validate="{ required: true, regex: /^[^\s@]+$/}"
        :placeholder="binding.label"
        :error="errors.has(getKey(binding)) ? true : false"
        :error-messages="cleanMessage(errors.first(getKey(binding)),getKey(binding),binding.label)"
        />
      </div>

      <div v-if="binding[getKey(binding)] == 'number'" class="flex xs12">
        <va-input
        :name="getKey(binding)"
        type="number"
        v-model="values[reports.active_module.module_name][getKey(binding)]"
        v-validate="{ required: true, regex: /^[0-9]+$/}"
        :placeholder="binding.label"
        :error="errors.has(getKey(binding)) ? true : false"
        :error-messages="cleanMessage(errors.first(getKey(binding)),getKey(binding),binding.label)"
        />
      </div>

    </template>

    <div class="flex xs12 text-right">

      <va-button @click="backToSearch()">Back</va-button>
      <va-button @click="render()">Generate Report</va-button>

    </div>


</va-card>
</div>

<div class="neovis-graph" v-bind:class="{ hidden: !show_neovis }">

  <span v-if="show_loader" class="visloader-wrapper">
           <va-icon
            class="vis-loader"
            name="va-icon fa fa-spin fa-spinner"
            color="primary"
            :large="true"
            size="120px"
            />
  </span>

  <div class="va-row viz-row">
    <div id="viz" ref="neovis"></div>
  </div>

  <div class="va-row tool-bar">

    <va-button class="run-query" large @click="backToSearch()"> 
      {{ (show_loader) ? "Cancel" : "Back" }} 
    </va-button>

    <va-button v-if="show_neovis && !show_loader" class="stabilize" large @click="stopPhysics()" >
      Stabilize
    </va-button>

  </div>

</div>

</div>

</template>

<script>

  import NeoVis from '@/mixins/NeoVisReportMixin';
  import { default as Reports } from './queries';
  import VueTagsInput from '@johmun/vue-tags-input';

  export default {
    props: [],
    mixins: [NeoVis],
    components: { "vue-tags-input": VueTagsInput },
    data () { 
      return {
        date:{
          label:"Find entites Between Time frame",
          config: {inline: true},
        },
      } 
    },

    methods: {

      getKey(object,prefix=false){

        if(prefix){
          return `${prefix}${Object.keys(object)[0]}`;
        }

        return Object.keys(object)[0]
      },

      cleanMessage(message,find,replace){

        if(message){
          return [message.replace(new RegExp(find, 'g'),replace).toLowerCase()];
        }

        return [];
        
      },

      async render(){

        try{

          let validate = await this.$validator.validateAll();

          if(validate) {

            this.assignConfig(this.reports.active_module.module.config);
            this.prepareQuery(this.reports.active_module.module.query, this.values[this.reports.active_module.module_name]);
            this.draw();
            
          }

        } catch(err) {
          this.setActive(false)
          this.show_neovis =false;
          console.error(err);
        }

      }

    },
    mounted() {

      this.setActive(false);
      this.setModules(Reports);

    }
  }
</script>
